<template>
  <div>
    <div class="title-cont">
      <h2 class="">Lieferanten</h2>
    </div>
    <div id="manage-suppliers" class="manage-suppliers-container">
      <div>
        <DataTable
          :value="allSuppliers"
          :paginator="true"
          class="p-datatable-products"
          :rows="10"
          :filters="filters"
          data-key="id"
          :loading="loading"
        >
          <template #header>
            <div class="table-header">
              <span class="p-text-left p-float-left">
                <Button label="Hinzufügen" icon="pi pi-plus" @click="addSupplier()" />
              </span>
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <input class="p-inputtext p-component" type="text"
                       v-model="filters['global']" placeholder="Suchen" />
              </span>
            </div>
          </template>
          <template #empty>Keine Modelle gefunden.</template>
          <template #loading>Lade alle Modelle...</template>
          <Column field="supplierId" header="id" sortable>
            <template #body="slotProps">{{
              slotProps.data.supplierId
            }}</template>
          </Column>
          <div class="p-fluid p-formgrid p-grid">
            <Column field="name" header="Name" sortable>
              <template #body="slotProps">
                <a href="#">{{ slotProps.data.name }}</a>
              </template>
            </Column>
          </div>
          <Column header="Aktionen">
            <template #body="slotProps">
              <a href="#" @click="editSupplier(slotProps.data)">
                <Button label="Bearbeiten" icon="pi pi-pencil p-button-warning" />
              </a>
              <a href="#" @click="deleteSupplier(slotProps.data)">
                <Button label="Löschen" icon="pi pi-trash p-button-danger" />
              </a>
            </template>
          </Column>
        </DataTable>
      </div>

      <Dialog
        header="Add New Supplier"
        :visible.sync="displayAddNewModal"
        :style="{ width: '50vw' }"
      >
        <div class="p-fluid">
          <div class="p-field">
            <label for="id">ID</label>
            <input id="id" v-model="newSupplier.supplierId"
                   class="p-inputtext p-component" type="text" />
          </div>
          <div class="p-field">
            <label for="name">Name</label>
            <input id="name" v-model="newSupplier.name"
                   class="p-inputtext p-component" type="text" />
          </div>
          <div class="p-field">
            <label for="agreementTime">Agreement Time</label>
            <input class="p-inputtext p-component"
              id="agreementTime"
              v-model="newSupplier.agreementTime"
              type="number"
            />
          </div>
          <div class="p-field">
            <label for="agreementTime">Browse logo</label>
            <FileUpload
              mode="basic"
              id="file"
              ref="file"
              name="logo"
              :multiple="false"
            />
          </div>
        </div>

        <template #footer>
          <Button
            label="SAVE"
            icon="pi pi-save"
            v-if="!isLoading"
            @click="createSupplier()"
            autofocus
          />
          <Button
            label="CLOSE"
            icon="pi pi-times-circle"
            @click="displayAddNewModal = false"
            v-if="!isLoading"
            autofocus
          />

          <ProgressSpinner
            v-if="isLoading"
            style="width: 20px; height: 20px"
            strokeWidth="8"
            fill="#EEEEEE"
            animationDuration=".5s"
          />
        </template>
      </Dialog>

      <Dialog
        header="Bearbeiten"
        :visible.sync="displayUpdateModal"
        :style="{ width: '50vw' }"
      >
        <div class="p-fluid">
          <div class="p-field">
            <label for="id">ID</label>
            <input
              id="id"
              v-model="selectedSupplier.supplierId"
              class="p-inputtext p-component" type="text"
            />
          </div>
          <div class="p-field">
            <label for="name">Name</label>
            <input id="name" v-model="selectedSupplier.name"
                   class="p-inputtext p-component" type="text" />
          </div>
          <div class="p-field">
            <label for="agreementTime">Vereinbarte Lieferzeit</label>
            <input class="p-inputtext p-component"
              id="agreementTime"
              v-model="selectedSupplier.agreementTime"
              type="number"
            />
          </div>
        </div>

        <template #footer>
          <Button
            label="Speichern"
            icon="pi pi-save"
            @click="updateSupplier()"
            v-if="!isLoading"
            autofocus
          />
          <Button
            label="Schließen"
            icon="pi pi-times-circle"
            @click="displayUpdateModal = false"
            v-if="!isLoading"
            autofocus
          />

          <ProgressSpinner
            style="width: 20px; height: 20px"
            strokeWidth="8"
            fill="#EEEEEE"
            animationDuration=".5s"
            v-if="isLoading"
          />
        </template>
      </Dialog>

      <Dialog
        header="Confirmation"
        :visible.sync="displayConfirmDeleteModal"
        :style="{ width: '350px' }"
        :modal="true"
      >
        <div class="confirmation-content">
          <i
            class="pi pi-exclamation-triangle p-mr-3"
            style="font-size: 2rem"
          />
          <span>Are you sure you want to delete the selected supplier?</span>
        </div>
        <template #footer>
          <Button
            label="No"
            icon="pi pi-times"
            @click="displayConfirmDeleteModal = false"
            class="p-button-text"
            v-if="!isLoading"
          />

          <ProgressSpinner
            v-if="isLoading"
            style="width: 20px; height: 20px"
            strokeWidth="8"
            fill="#EEEEEE"
            animationDuration=".5s"
          />

          <Button
            label="Yes"
            icon="pi pi-check"
            @click="confirmDelete()"
            class="p-button-text"
            autofocus
          />
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import {
  FETCH_SUPPLIERS,
  CREATE_SUPPLIER,
  UPDATE_SUPPLIER,
  DELETE_SUPPLIER
} from "../../../store/actions.type"
import Menubar from "primevue/menubar"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import Dropdown from "primevue/dropdown"
import Checkbox from "primevue/checkbox"
import Dialog from "../../../components/Dialog"
import Sidebar from "primevue/sidebar"
import ProgressSpinner from "primevue/progressspinner"
import "primeflex/primeflex.css"

import { mapGetters } from "vuex"
import axios from "axios"

export default {
  name: "suppliers",
  data() {
    return {
      suppliers: [],
      filters: {},
      loading: true,
      showList: false,
      representatives: null,
      displayAddNewModal: false,
      displayUpdateModal: false,
      displayConfirmDeleteModal: false,
      isLoading: false,
      file: '',
      newSupplier: {
        id: "",
        name: "",
        agreementTime: 0,
        file: '',
      },
      selectedSupplier: {
        _id: null,
        supplierId: "",
        name: "",
        agreementTime: ""
      }
    }
  },
  mounted() {
    if (!this.isAdmin()) this.$router.push("/suppliers")
  },
  methods: {
    fetchSuppliers() {
      let self = this
      this.$store.dispatch(FETCH_SUPPLIERS)
        .then((res) => {
          self.loading = false
        })
        .catch((err) => {
          console.log(err)
          self.loading = false
        })
    },
    addSupplier() {
      this.displayAddNewModal = true
    },
    editSupplier(supplier) {
      console.log(supplier.agreementTime)
      this.selectedSupplier = {
        _id: supplier._id,
        supplierId: supplier.supplierId,
        name: supplier.name,
        agreementTime: (supplier.agreementTime === undefined || supplier.agreementTime === "") ? 0 : supplier.agreementTime
      }
      this.displayUpdateModal = true
    },
    deleteSupplier(supplier) {
      this.selectedSupplier = {
        _id: supplier._id,
        supplierId: supplier.supplierId,
        name: supplier.name
      }
      this.displayConfirmDeleteModal = true
    },
    confirmDelete() {
      this.$store
        .dispatch(DELETE_SUPPLIER, this.selectedSupplier)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Successfully deleted the selected supplier",
            life: 3000
          })
          this.displayConfirmDeleteModal = false
          this.isLoading = false
          this.fetchSuppliers()
        })
        .catch(error => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 3000
          })
          this.isLoading = false
        })
    },
    updateSupplier() {
      this.isLoading = true
      this.$store
        .dispatch(UPDATE_SUPPLIER, this.selectedSupplier)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Successfully updated the selected supplier",
            life: 3000
          })
          this.fetchSuppliers()
          this.displayUpdateModal = false
          this.isLoading = false
        })
        .catch(error => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 3000
          })
          this.isLoading = false
        })
    },
    createSupplier() {
      this.isLoading = true

      // let formData = new FormData()
      // formData.append('supplierId', this.newSupplier.supplierId)
      // formData.append('name', this.newSupplier.name)
      // formData.append('agreementTime', this.newSupplier.agreementTime)

      // if (this.$refs.file.files[0]) {
      //   formData.append('file', this.$refs.file.files[0])
      // }

      this.$store
        .dispatch(CREATE_SUPPLIER, this.newSupplier)
        .then(() => {
          this.displayAddNewModal = false
          this.fetchSuppliers()
          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Successfully added new supplier",
            life: 3000
          })
          this.isLoading = false
          this.newSupplier = {
            id: "",
            name: "",
            agreementTime: 0
          }
          this.$refs.file.files[0] = ""
        })
        .catch(error => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 3000
          })
          this.isLoading = false
        })
    }
  },
  created() {
    if (!this.$msal.isAuthenticated()) {
      this.$router.push("/login")
    }
    if (this.$msal.isAuthenticated()) {
      this.fetchSuppliers()
    }
  },
  computed: {
    ...mapGetters(["allSuppliers"])
  },
  watch: {},
  components: {
    Menubar,
    DataTable,
    Column,
    Dropdown,
    Checkbox,
    Dialog,
    ProgressSpinner
  }
};
</script>

<style lang="scss">
.manage-suppliers-container {
  h2 {
    color: #2a3642;
  }
  .p-button {
    background: #293642;
    border: 1px solid #293642;
  }

  .p-datatable .p-sortable-column.p-highlight {
    background: #969696;
    color: #ffffff;
  }
}

.title-cont {
  padding: 2em;

  h2 {
    color: #2a3642;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/pages/admin/ManageSuppliers.vue